/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlHealthzAPIs
 */
export interface ControlHealthzAPIs {
    /**
     * 
     * @type {boolean}
     * @memberof ControlHealthzAPIs
     */
    admin_tools_gateway: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlHealthzAPIs
     */
    asm_api: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlHealthzAPIs
     */
    webserver_api: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlHealthzAPIs
     */
    vault_api: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlHealthzAPIs
     */
    auth0_api: boolean;
}

/**
 * Check if a given object implements the ControlHealthzAPIs interface.
 */
export function instanceOfControlHealthzAPIs(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "admin_tools_gateway" in value;
    isInstance = isInstance && "asm_api" in value;
    isInstance = isInstance && "webserver_api" in value;
    isInstance = isInstance && "vault_api" in value;
    isInstance = isInstance && "auth0_api" in value;

    return isInstance;
}

export function ControlHealthzAPIsFromJSON(json: any): ControlHealthzAPIs {
    return ControlHealthzAPIsFromJSONTyped(json, false);
}

export function ControlHealthzAPIsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlHealthzAPIs {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'admin_tools_gateway': json['admin_tools_gateway'],
        'asm_api': json['asm_api'],
        'webserver_api': json['webserver_api'],
        'vault_api': json['vault_api'],
        'auth0_api': json['auth0_api'],
    };
}

export function ControlHealthzAPIsToJSON(value?: ControlHealthzAPIs | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'admin_tools_gateway': value.admin_tools_gateway,
        'asm_api': value.asm_api,
        'webserver_api': value.webserver_api,
        'vault_api': value.vault_api,
        'auth0_api': value.auth0_api,
    };
}

